import React from 'react';
import { Tooltip } from '@mui/material';
import { MdInfo } from "react-icons/md";

const QBExplanationHeader = ({name}) => {
    return (
        <div className='explanation-col-header'>
            <div>Explanations</div>
            <div>
                <Tooltip arrow placement='top'
                    title={
                        <div className='fontClass-14'>
                            This column shows the total number of explanations for each {name}.
                            <br /><br />
                            Hover over the counts to see the breakdown.
                        </div>
                    }
                >
                    <div className='flex-center'><MdInfo fontSize={16} color='#707070' /></div>
                </Tooltip>
            </div>
        </div>
    );
}

export default QBExplanationHeader;
